"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachToThemesMode = void 0;
var attachToThemesMode = function (cssVariablesDark, cssVariablesLight) {
    return {
        '.dark': cssVariablesDark,
        '.light': cssVariablesLight,
    };
};
exports.attachToThemesMode = attachToThemesMode;
//# sourceMappingURL=attachToThemesMode.js.map